export default function PrivacyPolicy() {
	return (
		<div className="flex-1 container mx-auto px-4 py-12 md:py-20 max-w-4xl">
			<div className="bg-white/60 dark:bg-black/20 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-sky-900/10 dark:border-sky-100/10 shadow-sm">
				<h1 className="text-4xl md:text-5xl font-extrabold text-sky-950 dark:text-sky-50 mb-8">
					Privacy Policy
				</h1>

				<div className="space-y-8 text-sky-900/80 dark:text-sky-100/70 leading-relaxed">
					<p className="font-medium text-lg">Last updated: {new Date().toLocaleDateString()}</p>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">1. Introduction</h2>
						<p>
							At BeeDiv, we treat your financial data like the precious nectar it is. We are committed to
							protecting your personal information and your right to privacy. This policy explains what
							data we collect and how we use it to build a better hive.
						</p>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">2. Information We Collect</h2>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Account Information:</strong> When you sign up, we collect your email address
								and basic profile details.
							</li>
							<li>
								<strong>Financial Data:</strong> We store the portfolio data you manually enter or sync
								(tickers, share counts, cost basis) to calculate your dividends.
							</li>
							<li>
								<strong>Usage Data:</strong> We collect anonymous metrics on how you interact with our
								dashboard to improve the user experience.
							</li>
							<li>
								<strong>Email Digests:</strong> We use your email address to send optional weekly and
								monthly digest summaries of your portfolio activity. You can unsubscribe at any time
								from the link in any digest email or from your notification preferences page.
							</li>
						</ul>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">3. Third-Party Services</h2>
						<p>
							We do not sell your data. However, we use trusted third-party providers to operate our
							infrastructure. Data shared with these partners is strictly limited to what is necessary for
							their function:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Mixpanel:</strong> Analyzes user behavior (e.g., which features are used most)
								so we can optimize the product. Only activated with your consent.
							</li>
							<li>
								<strong>PostHog:</strong> Analyzes user behavior and records sessions to help us improve
								the product. Data hosted in EU. Only activated with your consent.
							</li>
							<li>
								<strong>Google Analytics (GA4):</strong> Measures traffic and usage patterns. Only
								activated with your consent. We use Google Consent Mode v2 — without consent, only
								cookieless aggregate signals are sent and no cookies are placed.
							</li>
							<li>
								<strong>Sentry:</strong> Captures error logs and crash reports so we can fix bugs
								quickly. Always active as it is essential for service reliability; it collects no
								marketing or behavioral data.
							</li>
							<li>
								<strong>SendGrid:</strong> Delivers our optional digest emails. Your email address is
								shared with SendGrid only when sending digests you have subscribed to. You can
								unsubscribe at any time.
							</li>
						</ul>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">4. Cookies &amp; Consent</h2>
						<p>BeeDiv uses cookies and local storage for two purposes:</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>
								<strong>Essential storage:</strong> Authentication tokens and your preferences (theme,
								currency, portfolio selection) stored in <code>localStorage</code>. Always active —
								required for the app to function.
							</li>
							<li>
								<strong>Analytics cookies:</strong> Set by our analytics providers to measure usage and
								improve the product. Only placed after you accept via the cookie banner.
							</li>
						</ul>
						<p>
							You can change your cookie preference at any time using the <strong>Cookie Settings</strong>{" "}
							link in the footer. Withdrawing consent will stop new data collection; previously collected
							analytics data may be retained by third-party providers per their own retention policies.
						</p>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">5. Data Security</h2>
						<p>
							We employ enterprise-grade encryption for data at rest and in transit. Your portfolio
							details are stored securely and are accessible only by you. While no hive is impenetrable,
							we implement industry best practices to keep the bears out.
						</p>
					</section>

					<section className="space-y-4">
						<h2 className="text-2xl font-bold text-sky-900 dark:text-sky-100">6. Contact Us</h2>
						<p>
							If you have questions about this policy, please contact our support team at
							privacy@beediv.com.
						</p>
					</section>
				</div>
			</div>
		</div>
	)
}
